import { AppState } from '../../../store/store'
export const selectAnvandare = (state: AppState) => state.anvandareReducer.data
